/* 
	<template>
		// 使用state标签，定义字典名称dict、值value
		<c-state dict="dictName" value="1"></c-state>
		// 使用异步数据定义async属性
		<c-state dict="dictName" async value="1"></c-state>
		
		// 下拉框、单复选框直接使用下面引入的选项数据
		<c-select :options="dictName"></c-select>
		<c-radio-group :options="dictName"></c-radio-group>
		<c-checkbox-group :options="dictName"></c-checkbox-group>
	</template>

	<script>
		// 获取本地选项数据
		// 导入mapState方法
		import {mapState} from 'vuex'
		export default {
			computed: {
				// 获取dictName选项数据
				...mapState(['dictName'])
			}
		}
		
		// 获取异步选项数据
		// 导入asyncMapState方法
		import {asyncMapState} from '@/store'
		export default {
			computed: {
				// 获取dictName选项数据
				...asyncMapState(['dictName'])
			}
		}
	</script>
 */

/* 支持颜色
 * gray 灰色
 * blue 蓝色
 * red 红色
 * green 绿色
 * yellow 黄色
 * orange 橙色
 */

export default {
	dictName: [{
		name: '状态1',
		value: 1,
		color: 'blue'
	}, {
		name: '状态2',
		value: 2,
		color: 'red'
	}],
	fieldType: [{
		name: '文本',
		value: 'text'
	}, {
		name: '数字',
		value: 'number'
	}, {
		name: '时间',
		value: 'time'
	}, {
		name: '选项',
		value: 'option'
	}, {
		name: '附件',
		value: 'file'
	}, {
		name: '图片',
		value: 'image'
	}],
	// 启用/停用
	disableEnableDic: [{
		name: '启用',
		value: 1,
		color: 'green'
	}, {
		name: '禁用',
		value: 2,
		color: 'gray'
	}],
	//关闭、开启
	openCloseDic: [{
		name: '关闭',
		value: 0,
		color: 'gray'
	}, {
		name: '开启',
		value: 1,
		color: 'red'
	}],
	//允许不允许
	allowDisallowDic: [{
		name: '不允许',
		value: 0,
		color: 'gray'
	}, {
		name: '允许',
		value: 1,
		color: 'red'
	}],
	//产品来源
	productSourceName: [{
		name: '自产',
		value: 1,
		color: 'green'
	},{
		name: '采购',
		value: 2,
		color: 'red'
	}],
	//产品类型
	productTypeName: [{
		name: '成品',
		value: 1,
		color: 'blue'
	},{
		name: '半成品',
		value: 3,
		color: 'orange'
	},  {
		name: '物料',
		value: 2,
		color: 'gray'
	}],
	//模板类型名称
	templateTypeName: [{
		name: '内置模板',
		value: 1,
		color: 'green'
	}, {
		name: 'Excel模板',
		value: 2,
		color: 'blue'
	}, {
		name: 'Excel模板',
		value: 3,
		color: 'brown'
	}],
	// 排产状态
	schedulingStateDic: [{
		name: '未排产',
		value: '0',
		color: 'orange'
	}, {
		name: '已排产',
		value: 1,
		color: 'green'
	}],
	// 订单状态
	salesOrderStateDic: [{
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已完成',
		value: 3,
		color: 'green'
	}, {
		name: '已取消',
		value: 4,
		color: 'orange'
	}],
	// 单据状态
	orderStateDic: [{
		name: '未开始',
		value: 1,
		color: 'gray'
	}, {
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已结束',
		value: 3,
		color: 'green'
	}, {
		name: '已取消',
		value: 4,
		color: 'orange'
	}],
	// 单据状态(不含取消)
	orderStateNoCancelDic: [{
		name: '未开始',
		value: 1,
		color: 'gray'
	}, {
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已结束',
		value: 3,
		color: 'green'
	}],
	//优先级
	priorityDic: [
		{
			name: '',
			value: 0,
			color: 'gray'
		},
		{
			name: '加急',
			value: 1,
			color: 'red'
		}, {
			name: '暂停',
			value: 2,
			color: 'gray'
		},
	],
	//审核状态（含待提交）
	auditStateDic:[
		{
			name: '待提交',
			value: 0,
			color: 'gray'
		}, {
			name: '待审核',
			value: 1,
			color: 'blue'
		}, {
			name: '已审核',
			value: 2,
			color: 'green'
		}
	],
	//计价方式
	pricingTypeDic:[{
		name: '计件',
		value: 1,
		color: 'black'
	}, {
		name: '计时',
		value: 2,
		color: 'orange'
	}],
	//售后工单状态
	afterSaleOrderStateDic: [
		{name: '草稿', value: 0, color: 'gray'},
		{name: '待派单', value: 1, color: 'red'},
		{name: '待确认', value: 6, color: 'orange'},
		{name: '待服务', value: 2, color: 'blue'},
		{name: '服务中', value: 3, color: 'blue'},
		{name: '待验收', value: 4, color: 'blue'},
		{name: '已完工', value: 5, color: 'green'},
		{name: '已关闭', value: 10, color: 'gray'}
	],
	//我的售后工单状态
	mineAfterSaleOrderStateDic: [
		{name: '待确认', value: 6, color: 'orange'},
		{name: '待服务', value: 2, color: 'blue'},
		{name: '服务中', value: 3, color: 'blue'},
		{name: '待验收', value: 4, color: 'blue'},
		{name: '已完工', value: 5, color: 'green'}
	],
	// 紧急程度
	urgencyLevelDic: [
		{name: '普通', value: 1, color: 'gray'},
		{name: '重要', value: 2, color: 'orange'},
		{name: '加急', value: 3, color: 'red', icon: '\ue657'}
	],
	// 请假类型
	leaveTypeDic: [
		{name: '事假', value: 1, color: 'blue'},
		{name: '病假', value: 2, color: 'orange'},
		{name: '年假', value: 3, color: 'green'},
		{name: '婚假', value: 4, color: 'purple'},
		{name: '产假', value: 5, color: 'pink'},
		{name: '丧假', value: 6, color: 'gray'},
		{name: '其他', value: 7, color: 'default'},
		{name: '育儿假', value: 8, color: 'green'},
		{name: '调休', value: 9, color: 'green'}
	],
	// 加班类型
	overtimeTypeDic: [
		{name: '工单加班', value: 1, color: 'blue'},
		{name: '普通加班', value: 2, color: 'gray'}
	],
	//时间段
	timePeriodDic: [
		{name: '上午', value: 1, color: 'blue'},
		{name: '下午', value: 2, color: 'blue'},
		{name: '全天', value: 3, color: 'blue'}
	],
	//是否使用机台
	useMachineOptions: [{
		name: '使用',
		value: 1,
		color: 'green'
	}, {
		name: '不使用',
		value: 0,
		color: 'gray'
	}],
	//出行方式
	travelModeOptions: [{
		name: '开公司车',
		value: 1,
		color: 'green'
	}, {
		name: '公共交通',
		value: 2,
		color: 'orange'
	}, {
		name: '其它',
		value: 3,
		color: 'gray'
	}],

	//系统操作类型
	operationName:[
		{name: '创建', value: 1, color: 'green'},
		{name: '编辑', value: 2, color: 'blue'},
		{name: '删除', value: 3, color: 'red'},
		{name: '导出', value: 4, color: 'blue'},
		{name: '导入', value: 5, color: 'blue'},
		{name: '启/禁用', value: 6, color: 'blue'},
		{name: '取消派单', value: 20, color: 'red'},
		{name: '手动派单', value: 21, color: 'blue'},
		{name: '自动派单', value: 29, color: 'teal'},
	],
	//工单相关操作类型
	orderOperationName:[
		{name: '手动派单', value: 21, color: 'blue'},
		{name: '拒单', value: 22, color: 'blue'},
		{name: '报工', value: 23, color: 'blue'},
		{name: '验收申请', value: 24, color: 'blue'},
		{name: '确认预约时间', value: 25, color: 'blue'},
		{name: '添加成员', value: 26, color: 'blue'},
		{name: '工单评价', value: 27, color: 'blue'},
		{name: '考勤打卡', value: 28, color: 'blue'},
		{name: '自动派单', value: 29, color: 'blue'},
		{name: '完工', value: 30, color: 'blue'},
		{name: '移除成员', value: 31, color: 'red'},
		{name: '确认服务时长', value: 33, color: 'blue'},
		{name: '处理单确认', value: 35, color: 'blue'}
	],
	//导入操作状态
	importStateName:[
		{name: '导入失败', value: 0, color: 'red'},
		{name: '部分成功', value: 1, color: 'yellow'},
		{name: '导入成功', value: 2, color: 'green'}
	],
	//外协单动态类型
	outSourcingOrderProcessName:[
		{name: '发货', value: 1, color: 'blue'},
		{name: '收货', value: 2, color: 'green'}
	],
	//外协单动态创建人类型(1=供应商 2=工厂用户)
	outSourcingOrderProcessCreateUserType:[
		{name: '供应商', value: 1, color: 'blue'},
		{name: '系统用户', value: 2, color: 'green'}
	],
	//报表时间粒度
	timeGranule: [{
		name: '每天',
		value: 'DAY'
	}, {
		name: '每周',
		value: 'WEEK'
	}, {
		name: '每月',
		value: 'MONTH'
	}],
	//库存状态
	stockStateName: [
		{name: '未设置', value: -1, color: 'gray'},
		{name: '低预警', value: 1, color: 'red'},
		{name: '正常', value: 2},
		{name: '超预警', value: 3, color: 'blue'}
	],
	//订单库存占用状态
	occStatedic: [{
		name: '未占用',
		value: 1,
		color: 'gray'
	},{
		name: '已占用',
		value: 2,
		color: 'blue'
	}],
	//加工类型
	processTypeDic: [{
		name: '自制',
		value: 1,
		color: ''
	}, {
		name: '外协',
		value: 2,
		color: 'blue'
	}],
	//检验方式
	testModeDic: [{
		name: '免检',
		value: 1,
		color: 'green'
	}, {
		name: '首检',
		value: 2,
		color: 'blue'
	}, {
		name: '全检',
		value: 3,
		color: 'orange'
	}],
	//检验状态
	testStateDic: [{
		name: '免检',
		value: 1,
		color: 'gray'
	}, {
		name: '未质检',
		value: 2,
		color: 'orange'
	}, {
		name: '已质检',
		value: 3,
		color: 'green'
	}],
	//报工类型
	outputTypeDic: [{
		name: '正常',
		value: 1,
		color: 'gray'
	}, {
		name: '返工',
		value: 2,
		color: 'orange'
	}],
	//不合格品处理状态
	afterStateDic: [{
		name: '未处理',
		value: 1,
		color: 'blue'
	}, {
		name: '已处理',
		value: 2,
		color: 'green'
	}],
	//首检状态
	firestTestState: [{
		name: '未完成',
		value: 1,
		color: 'blue'
	}, {
		name: '已完成',
		value: 2,
		color: 'green'
	}],
	//用户类型
	userTypeDic: [{
		name: '员工',
		value: 1,
		color: 'blue'
	}, {
		name: '客户',
		value: 2,
		color: 'gray'
	}],
	//账户锁定状态
	lockStateDic: [{
		name: '正常',
		value: 0,
		color: 'green'
	}, {
		name: '已锁定',
		value: 1,
		color: 'red'
	}],


	//售后申请单转单状态
	orderTransferStatusDic: [{
		name: '待转单',
		value: 0,
		color: 'gray'
	}, {
		name: '已挂起',
		value: 2,
		color: 'orange'
	}, {
		name: '已转单',
		value: 1,
		color: 'green'
	}
	],
	//资产状态 正常、维护中、已报废
	assetStatusDic: [
		{
			name: '正常',
			value: 1,
			color: 'green'
		}, {
			name: '维修中',
			value: 2,
			color: 'red'
		}, {
			name: '已报废',
			value: 3,
			color: 'gray'
		}
	],
	assetUseStatusDic: [
		{
			name: '空闲',
			value: 1,
			color: 'green'
		}, {
			name: '占用中',
			value: 2,
			color: 'blue'
		}
	],
	//资产借用状态
	borrowStatusDic: [{
		name: '-',
		value: 0,
		color: 'gray'
	}, {
		name: '借用中',
		value: 1,
		color: 'red'
	}],
	//资产分类
	assetCategoryDic: [
		{
			name: '车辆',
			value: '车辆',
			color: 'gray'
		}, {
			name: '机台',
			value: '机台',
			color: 'blue'
		}
	],
	//资产领用单状态 -1-草稿、1-审批中、2-审批通过、3-已驳回、4-已撤销
	applyStatusDic: [
		{
			name: '草稿',
			value: -1,
			color: 'gray'
		}, {
			name: '审批中',
			value: 1,
			color: 'blue'
		}, {
			name: '审批通过',
			value: 2,
			color: 'green'
		}, {
			name: '已驳回',
			value: 3,
			color: 'orange'
		}, {
			name: '已撤销',
			value: 4,
			color: 'red'
		}
	],
	//资产归还单状态 -1-草稿、1-审批中、2-审批通过、3-已驳回、4-已撤销
	returnStatusDic: [
		{
			name: '草稿',
			value: -1,
			color: 'gray'
		}, {
			name: '审批中',
			value: 1,
			color: 'blue'
		}, {
			name: '审批通过',
			value: 2,
			color: 'green'
		}, {
			name: '已驳回',
			value: 3,
			color: 'orange'
		}, {
			name: '已撤销',
			value: 4,
			color: 'red'
		}
	],
	//招工类型
	recruitTypeDic: [
		{
			name: '临时',
			value: 1,
			color: 'blue'
		}, {
			name: '长期',
			value: 2,
			color: 'green'
		}, {
			name: '项目制',
			value: 3,
			color: 'orange'
		}, {
			name: '其他',
			value: 4,
			color: 'red'
		}
	],
	evaluateStatusDic: [
		{
			name: '待评价',
			value: 0,
			color: 'orange'
		}, {
			name: '已评价',
			value: 1,
			color: 'green'
		}
	],
	suggestionTypcDic:[
		{
			name: '投诉',
			value: 1,
			color: 'red'
		}, {
			name: '建议',
			value: 2,
			color: 'blue'
		}
	],
	suggestionStateDic:[
		{
			name: '待处理',
			value: 1,
			color: 'orange'
		}, {
			name: '已处理',
			value: 2,
			color: 'green'
		}
	],
	//流程审核状态 1.同意、2.驳回、3.撤回、4，发起、5，重新发起、9.驳回起点
	workflowExecuteStateOptions: [{
		name: '发起',
		value: 4,
		color: 'blue'
	},{
		name: '撤回',
		value: 3,
		color: 'darkgray'
	}, {
		name: '同意',
		value: 1,
		color: 'green'
	}, {
		name: '驳回',
		value: 2,
		color: 'red'
	}, {
		name: '重新发起',
		value: 5,
		color: 'darkgray'
	}, {
		name: '驳回起点',
		value: 9,
		color: 'orange'
	}, {
		name: '待审批',
		value: 0,
		color: 'red'
	}, {
		name: '跳过',
		value: 6,
		color: 'darkgray'
	}],
	//报销类型 1=差旅费用
	reimbursementTypeDic: [
		{ name: '工单费用报销', value: 1, color: 'blue' },
		{ name: '日常费用报销', value: 2, color: 'green' }
	],
	//报销项类型 1=公用 2=个人
	expenseItemTypeDic: [
		{ name: '公共费用', value: 1, color: 'blue' },
		{ name: '个人费用', value: 2, color: 'orange' },
		{ name: '一般费用', value: 3, color: 'green' }
	],
	expenseItemCodeDic: [
		{ name: '住宿费', value: 1, color: '' },
		{ name: '餐费', value: 2, color: '' },
		{ name: '飞机票', value: 3, color: '' },
		{ name: '火车票', value: 4, color: '' },
		{ name: '其他（个人费用）', value: 11, color: '' },

		{ name: '打车、地铁、公交费用', value: 5, color: '' },
		{ name: '过路费', value: 6, color: '' },
		{ name: '加油费', value: 7, color: '' },
		{ name: '小工费用', value: 8, color: '' },
		{ name: '租车费用', value: 9, color: '' },
		{ name: '停车费', value: 12, color: '' },
		{ name: '快递费', value: 13, color: '' },
		{ name: '机物料', value: 14, color: '' },
		{ name: '其他（租、买工具)', value: 10, color: '' },
		{ name: '运输费', value: 21, color: '' },
		{ name: '福利费', value: 22, color: '' },
		{ name: '软件服务费', value: 23, color: '' },
		{ name: '维修费', value: 24, color: '' },
		{ name: '油费', value: 25, color: '' },
		{ name: '设备', value: 26, color: '' },
		{ name: '辅料', value: 27, color: '' },
		{ name: '车辆（设备）保养', value: 28, color: '' },
		{ name: '垃圾清理费', value: 29, color: '' },
		{ name: '五金配件费用', value: 30, color: '' },
		{ name: '工厂聚餐费', value: 31, color: '' },
		{ name: '餐费', value: 32, color: '' },
		{ name: '住宿费', value: 33, color: '' },
		{ name: '公共交通费用', value: 34, color: '' },
	],
	dispatchRuleTypeDic: [
		{ name: '筛选规则', value: 1 ,color: 'blue'},
		{ name: '排序规则', value: 2 ,color: 'green'}
	],
	//服务类型枚举
	serviceTypeDic: [
		{ name: '售前服务', value: 1 ,color: 'blue'},
		{ name: '售后服务', value: 2 ,color: 'orange'}
	],
	//售后类型枚举
	afterSaleTypeDic: [
		{ name: '正常售后', value: 1 ,color: 'blue'},
		{ name: '质量问题售后', value: 2 ,color: 'red'}
	],
	//客户级别
	customerLevelDic: [
		{ name: 'C', value: 1 ,color: 'blue'},
		{ name: 'B', value: 2 ,color: 'green'},
		{ name: 'A', value: 3 ,color: 'orange'}
	],
	//公司性质枚举
	companyNatureDic: [
		{ name: '上市公司', value: 1 ,color: 'blue'},
		{ name: '私人有限公司', value: 2 ,color: 'blue'},
		{ name: '中外合资', value: 3 ,color: 'blue'},
		{ name: '外商独资', value: 4 ,color: 'blue'},
		{ name: '国营', value: 5 ,color: 'blue'}
	],
	//同行地位枚举
	industryStatusDic: [
		{ name: '领导者', value: 1 ,color: 'blue'},
		{ name: '具影响力', value: 2 ,color: 'blue'},
		{ name: '中等', value: 3 ,color: 'blue'},
		{ name: '小型厂商', value: 4 ,color: 'blue'},
		{ name: '其他', value: 5 ,color: 'blue'}
	],
	//发展趋势枚举
	developmentTrendDic: [
		{ name: '上升', value: 1 ,color: 'blue'},
		{ name: '平稳', value: 2 ,color: 'blue'},
		{ name: '下降', value: 3 ,color: 'blue'},
		{ name: '其他', value: 4 ,color: 'blue'}
	],
	//是否新客户枚举
	newCustomerDic: [
		{ name: '新客户', value: 1 ,color: 'blue'},
		{ name: '非新客户', value: 2 ,color: 'blue'}
	],
	// 已读/未读
	readFlagStateDic: [
		{name: '未读', value: 1, color: 'red'},
		{name: '已读', value: 2, color: 'green'}
	],
	//售后工单成员状态：0-待出发，1-出发，2-到达，3-完工，4-已回到网点
	orderMemberStatusDic: [
		{name: '待出发', value: 0, color: 'gray'},
		{name: '已出发', value: 1, color: 'blue'},
		{name: '已到达', value: 2, color: 'blue'},
		{name: '已完工', value: 3, color: 'green'},
		{name: '已回到网点', value: 4, color: 'gray'}
	],
	isChargeDic: [
		{name: '否', value: 2, color: 'gray'},
		{name: '是', value: 1, color: 'green'}
	],
	//工单是否逾期
	isDelayedDic: [
		{name: '未逾期', value: 0, color: 'gray'},
		{name: '逾期', value: 1, color: 'red'}
	],
	//处理单确认状态
	complaintConfirmStatusDic: [
		{name: '待确认', value: 1, color: 'orange'},
		{name: '已确认', value: 2, color: 'green'}
	],
	//费用类型
	feeCategoryDic: [
		{name: '车辆费用', value: 1, color: 'blue'},
		{name: '员工费用', value: 2, color: 'gray'},
		{name: '设备费用', value: 3, color: 'orange'},
	],
	//费用类型
	feeTypeDic: [
		{name: '车辆折旧', value: 1, color: 'blue'},
		{name: '油耗', value: 2, color: 'blue'},
		{name: '过路费', value: 3, color: 'blue'},
		{name: '人员成本', value: 4, color: 'blue'},
		{name: '住宿费', value: 5, color: 'blue'},
		{name: '伙食费', value: 6, color: 'blue'},
		{name: '机台费用', value: 7, color: 'blue'},
		{name: '交通费', value: 8, color: 'blue'},
	],

	//费用类型-实际费用
	feeTypeActualDic: [
		{name: '车辆折旧', value: 1, color: 'blue'},
		{name: '油耗', value: 2, color: 'blue'},
		{name: '过路费', value: 3, color: 'blue'},
		{name: '人员成本', value: 4, color: 'blue'},
		{name: '住宿费', value: 5, color: 'blue'},
		{name: '伙食费', value: 6, color: 'blue'},
		{name: '机台费用', value: 7, color: 'blue'},
		{name: '交通费', value: 8, color: 'blue'},
		{name: '小工费用', value: 9, color: 'blue'},
		{name: '租车费用', value: 10, color: 'blue'},
		{name: '其他费用-公共', value: 11, color: 'blue'},
		{name: '其他费用-个人', value: 12, color: 'blue'},
	],
	//申请单标签
	applyTagDic: [
		{name: '测试单据', value: '测试单据', color: 'orange'},
	],
	applyTagShortDic: [
		{name: '测', value: '测', color: 'orange'},
	],
	//推送模式
	pushCrmModelDic: [
		{name: '全部推送', value: 1},
		{name: '仅推送测试标签工单', value: 2},
		{name: '关闭推送', value: 3},
	],
	//节假日类型
	holidayTypeDic: [
		{name: '工作日', value: 0, color: 'black'},
		{name: '法定节日', value: 1, color: 'yellow'},
		{name: '调休工作日', value: 2, color: 'red'},
		{name: '公司假', value: 3, color: 'blue'},
		{name: '调休休息日', value: 4, color: 'green'},
		{name: '周末', value: 9, color: 'brown'}
	],
	//是否已分配网点
	isOutletAssignedDic: [
		{name: '是', value: 1, color: 'green'},
		{name: '否', value: 2, color: 'red'},
	],
	// 工单投诉类型
	complaintTypeDic: [
		{name: '质量问题', value: 1, color: 'blue'},
	],
	//访问来源 0:WEB，1:移动端
	refClientOptions: [
		{name: 'PC端', value: 0, color: 'green'},
		{name: '移动端', value: 1, color: 'blue'}
	],
	//打卡方式
	signTypeOptions: [
		{name: '出发打卡', value: 1, color: 'black'},
		{name: '到达打卡', value: 2, color: 'yellow'},
		{name: '上班打卡', value: 3, color: 'green'},
		{name: '下班打卡', value: 4, color: 'blue'},
		{name: '回网点打卡', value: 5, color: 'gray'},
	],
	//接头方式
	connectionMethodDic: [
		{name: '热接 (平齿接/非斜齿)', value: 1, color: 'blue'},
		{name: '热接（斜齿接）', value: 2, color: 'blue'},
		{name: '热接（搭接）', value: 3, color: 'blue'},
		{name: '热接（斜搭接）', value: 4, color: 'blue'},
		{name: '扣接（钢扣）', value: 5, color: 'blue'},
		{name: '扣接（尼龙扣）', value: 6, color: 'blue'},
		{name: '扣接（塑料扣）', value: 7, color: 'blue'},
		{name: '冷接', value: 8, color: 'blue'},
		{name: '开口带', value: 9, color: 'blue'},
		{name: '斜单长齿接', value: 10, color: 'blue'},
		{name: '开口打齿', value: 11, color: 'blue'},
		{name: '齿接环带', value: 12, color: 'blue'},
		{name: '接驳', value: 13, color: 'blue'},
		{name: '环形', value: 14, color: 'blue'},
		{name: '环带', value: 15, color: 'blue'},
		{name: '无缝', value: 16, color: 'blue'},
		{name: '细长齿接', value: 17, color: 'blue'},
		{name: '牛鼻子接头', value: 18, color: 'blue'},
		{name: '30 斜单齿接', value: 19, color: 'blue'},
		{name: '单层齿接', value: 20, color: 'blue'},
		{name: '反齿接', value: 21, color: 'blue'},
		{name: '细短齿接', value: 22, color: 'blue'},
		{name: '70 度斜齿接', value: 23, color: 'blue'},
		{name: '对接', value: 24, color: 'blue'},
		{name: '多层齿接', value: 25, color: 'blue'},
		{name: '上齿下搭', value: 26, color: 'blue'},
		{name: 'PPJ 穿销接头', value: 27, color: 'blue'},
		{name: '大圆弧齿形', value: 28, color: 'blue'},
		{name: '小圆弧齿形', value: 29, color: 'blue'},
		{name: '菱形齿', value: 30, color: 'blue'},
		{name: '开口打平齿', value: 31, color: 'blue'},
		{name: '开口打斜齿', value: 32, color: 'blue'},
	],

	//节假日类型
	overtimeDayTypeDic: [
		{name: '工作日加班', value: 0},
		{name: '节日加班', value: 1},
		{name: '工作日加班', value: 2,},
		{name: '休息日加班', value: 3,},
		{name: '休息日加班', value: 4,},
		{name: '休息日加班', value: 9,},
	],
	// 维修类型
	repairTypeDic: [
		{name: '出现故障现象', value: 1, color: 'blue'},
		{name: '维修更换部件', value: 2, color: 'blue'},
	],
	// 维修状态
	repairStatusDic: [
		{name: '维修中', value: 1, color: 'red'},
		{name: '已完成', value: 2, color: 'green'}
	],
	// 接单状态
	receiveStatusDic: [{
		name: '正常接单',
		value: 1,
		color: 'green'
	}, {
		name: '暂停接单',
		value: 2,
		color: 'gray'
	}],
	// 临时支援状态
	tempSupportStatusDic: [{
		name: '支援中',
		value: 1,
		color: 'green'
	}, {
		name: '未支援',
		value: 2,
		color: 'gray'
	}],
	userGroupDic:[
		{
			name: '网点负责人',
			value: 1,
			color: 'green'
		}
	],
	starLevelDic: [
		{
			name: '1星',
			value: 1,
		},
		{
			name: '2星',
			value: 2,
		},
		{
			name: '3星',
			value: 3,
		},
	],
	mqErrorLogFlagDic: [
		{name: '未处理', value: 0, color: 'red'},
		{name: '已处理', value: 1, color: 'green'},
	],
}